import React from 'react';
import { StepContainer } from '../StepContainer';
import { FormSection } from './form/formSection';
import { FormItem } from './form/formItem';

interface RevetementsStepProps {
  data: any;
  onChange: (data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const RevetementsStep: React.FC<RevetementsStepProps> = ({
  data = {
    preparationSupports: {},
    revetementsMuraux: {},
    revetementsSols: {},
    plinthes: {},
    escaliers: {},
    amenagements: {}
  },
  onChange,
  onNext,
  onBack
}) => {
  const updateSection = (section: string, key: string, value: any) => {
    onChange({
      ...data,
      [section]: {
        ...data[section],
        [key]: value
      }
    });
  };

  return (
    <StepContainer
      title="Revêtements (Sols et Murs)"
      description="Détaillez les travaux de revêtements à réaliser"
      onNext={onNext}
      onBack={onBack}
    >
      <div className="space-y-6">
        <FormSection
          title="1. Préparation des supports"
          description="Préparation des surfaces avant application des revêtements"
        >
          <div className="space-y-4">
            <FormItem
              label="Râtissage de murs abîmés"
              value={data.preparationSupports?.ratissageMurs || { selected: false }}
              onChange={(value) => updateSection('preparationSupports', 'ratissageMurs', value)}
              withSurface
            />
            <FormItem
              label="Râtissage de plafonds abîmés"
              value={data.preparationSupports?.ratissagePlafonds || { selected: false }}
              onChange={(value) => updateSection('preparationSupports', 'ratissagePlafonds', value)}
              withSurface
            />
            <FormItem
              label="Râtissage de plafonds placo neufs"
              value={data.preparationSupports?.ratissagePlacoNeufs || { selected: false }}
              onChange={(value) => updateSection('preparationSupports', 'ratissagePlacoNeufs', value)}
              withSurface
            />
          </div>
        </FormSection>

        <FormSection
          title="2. Revêtements"
          description="Pose ou rénovation de revêtements muraux et plafonds"
        >
          <div className="space-y-4">
            <FormItem
              label="Peinture murale"
              value={data.revetementsMuraux?.peinture || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'peinture', value)}
              withSurface
            />
            <FormItem
              label="Papier peint"
              value={data.revetementsMuraux?.papierPeint || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'papierPeint', value)}
              withSurface
            />
            <FormItem
              label="Enduit décoratif"
              value={data.revetementsMuraux?.enduitDecoratif || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'enduitDecoratif', value)}
              withSurface
            />
            <FormItem
              label="Carrelage mural"
              value={data.revetementsMuraux?.carrelageMural || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'carrelageMural', value)}
              withSurface
            />
            <FormItem
              label="Peinture plafond standard"
              value={data.revetementsMuraux?.peinturePlafond || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'peinturePlafond', value)}
              withSurface
            />
            <FormItem
              label="Peinture plafonds hauts >2,5m"
              value={data.revetementsMuraux?.peinturePlafondHaut || { selected: false }}
              onChange={(value) => updateSection('revetementsMuraux', 'peinturePlafondHaut', value)}
              withSurface
            />
          </div>
        </FormSection>

        <FormSection
          title="3. Revêtements de sols"
          description="Pose ou rénovation de revêtements de sols"
        >
          <div className="space-y-4">
            <FormItem
              label="Carrelage"
              value={data.revetementsSols?.carrelage || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'carrelage', value)}
              withSurface
            />
            <FormItem
              label="Parquet massif"
              value={data.revetementsSols?.parquetMassif || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'parquetMassif', value)}
              withSurface
            />
            <FormItem
              label="Ponçage parquet ancien"
              value={data.revetementsSols?.poncageParquet || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'poncageParquet', value)}
              withSurface
            />
            <FormItem
              label="Parquet stratifié"
              value={data.revetementsSols?.parquetStratifie || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'parquetStratifie', value)}
              withSurface
            />
            <FormItem
              label="Moquette"
              value={data.revetementsSols?.moquette || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'moquette', value)}
              withSurface
            />
            <FormItem
              label="Sol en vinyle ou PVC"
              value={data.revetementsSols?.vinyle || { selected: false }}
              onChange={(value) => updateSection('revetementsSols', 'vinyle', value)}
              withSurface
            />
          </div>
        </FormSection>

        <FormSection
          title="4. Plinthes"
          description="Installation ou remplacement de plinthes"
        >
          <div className="space-y-4">
            <FormItem
              label="Plinthes en bois"
              value={data.plinthes?.bois || { selected: false }}
              onChange={(value) => updateSection('plinthes', 'bois', value)}
              withLength
            />
            <FormItem
              label="Plinthes en PVC"
              value={data.plinthes?.pvc || { selected: false }}
              onChange={(value) => updateSection('plinthes', 'pvc', value)}
              withLength
            />
          </div>
        </FormSection>

        <FormSection
          title="5. Escaliers"
          description="Pose de revêtements sur escaliers"
        >
          <div className="space-y-4">
            <FormItem
              label="Revêtement en bois (nombre de marches)"
              value={data.escaliers?.bois || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'bois', value)}
              withQuantity
            />
            <FormItem
              label="Revêtement en carrelage (nombre de marches)"
              value={data.escaliers?.carrelage || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'carrelage', value)}
              withQuantity
            />
            <FormItem
              label="Revêtement en moquette (nombre de marches)"
              value={data.escaliers?.moquette || { selected: false }}
              onChange={(value) => updateSection('escaliers', 'moquette', value)}
              withQuantity
            />
          </div>
        </FormSection>

        <FormSection
          title="6. Aménagements spécifiques"
          description="Aménagements spécifiques de revêtements"
        >
          <div className="space-y-4">
            <FormItem
              label="Revêtement mural acoustique"
              value={data.amenagements?.acoustique || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'acoustique', value)}
              withSurface
            />
            <FormItem
              label="Sol chauffant"
              value={data.amenagements?.solChauffant || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'solChauffant', value)}
              withSurface
            />
            <FormItem
              label="Revêtement antidérapant"
              value={data.amenagements?.antiderapant || { selected: false }}
              onChange={(value) => updateSection('amenagements', 'antiderapant', value)}
              withSurface
            />
          </div>
        </FormSection>
      </div>
    </StepContainer>
  );
};

export default RevetementsStep;